import { Box, Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

// Footer for the public marketing pages (/, /about, /pricing, /quote and the legal routes) —
// logo and "© ReVisionari LLC." on the left, Privacy / Terms / Contact links on the right.
// See MARKETING_FOOTER_ROUTES in App.js for the exact list.
//
// This is the ONLY entry point to the legal document — it is deliberately not in any page's
// nav row. That makes the link styling load-bearing rather than decorative: Privacy and Terms
// are brand purple at 13px, not the #6B6B6B the surrounding meta text uses, so they read as
// links from across the footer bar.
export default function HomeFooter() {
  // Live links. Contact is excluded — it still has no destination, and styling a dead link to
  // look this clickable is worse than leaving it muted.
  const linkSx = {
    color: '#413B8D',        // theme.js primary.main
    fontSize: 13,
    fontWeight: 500,
    '&:hover': { color: '#6B4F14', textDecoration: 'underline' },  // gold-deep, as on /legal
  };

  return (
    <Box sx={{ maxWidth: 1100, mx: 'auto', mt: 'auto', width: '100%' }}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1.5,
          px: { xs: 2, sm: 4 },
          py: 2.25,
          fontSize: 12,
          color: '#6B6B6B',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Box
            component={RouterLink}
            to="/"
            aria-label="ReVisionari home"
            sx={{ display: 'inline-flex', lineHeight: 0 }}
          >
            <Box
              component="img"
              src="/images/revisionari-logo.png"
              alt="ReVisionari"
              sx={{ height: 26, width: 'auto', display: 'block' }}
            />
          </Box>
          <Box component="span">&copy; ReVisionari LLC.</Box>
        </Box>
        <Box component="span" sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* Both point at the same document — /legal renders the EULA and the privacy policy
              as Part I and Part II, and these two routes open it on the relevant half. */}
          <Link component={RouterLink} to="/privacy" underline="none" sx={linkSx}>Privacy</Link>
          <Link component={RouterLink} to="/terms" underline="none" sx={linkSx}>Terms</Link>
          {/* Still a dead link: there's no /contact route and no confirmed public mailbox yet. */}
          <Link href="#" underline="none" sx={{ color: '#6B6B6B', fontSize: 12 }}>Contact</Link>
        </Box>
      </Box>
    </Box>
  );
}
